import http from './http';

export default {
  all() {
    return http().get(`/v1/campaigns`);
  },
  get(id) {
    return http().get(`/v1/campaigns/${id}`);
  },
  getUnitCounts(campaignId) {
    return http().get(`/v1/campaigns/${campaignId}/unit-counts`);
  },
  create(data) {
    return http().post(`/v1/campaigns`, data);
  },
  update(data) {
    return http().put(`/v1/campaigns/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/campaigns/${id}`);
  },
  restore(id) {
    return http().put(`/v1/campaigns/${id}/restore`);
  },
  updateIntegrationNumber(data) {
    return http().put(`/v1/campaigns/${data.id}/integration_phone_number`, data);
  }
}
